import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthService from "../services/AuthService";
import { useClient } from "../context/ClientContext";
import { useNotification } from "../context/NotificationContext";

const AfterLoginGuard: React.FC = () => {
  const notification = useNotification();
  const client = useClient("AUTH_SERVICE");
  const authService = new AuthService(client, notification);

  return authService.isAuthenticated() ? <Outlet /> : <Navigate to="/login" />;
};

export default AfterLoginGuard;
